import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import InfoTooltip from "Shared/InfoTooltip";
import WithDefaults from "Shared/WithDefaults";
import styled from "styled-components";

const Root = styled("span")<{ displayTooltip: boolean | undefined }>`
    align-items: center;
    color: ${(props) => props.theme.palette.grey[100]};
    display: flex;
    flex-wrap: wrap;
    justify-content: ${(props) => (props.displayTooltip ? "flex-start" : "center")};
    margin: 0 0 6px;
`;

const Header = styled("span")<{ displayTooltip: boolean | undefined; displayDealerNumber: boolean | undefined }>`
    flex: ${(props) => (props.displayTooltip ? "0 0 auto" : "0 0 100%")};
    font-size: ${(props) => (props.displayDealerNumber ? "20px" : props.displayTooltip ? "1em" : "20px")};
    font-weight: bold;
    text-align: ${(props) => (props.displayDealerNumber ? "right" : "center")};

    ${(props) => props.theme.breakpoints.up("desktop")} {
        font-size: ${(props) => (props.displayDealerNumber ? "20px" : props.displayTooltip ? "1.4em" : "26px")};
    }
`;

const DealerNumber = styled("span")`
    font-size: 30px;
    font-weight: bold;
`;

const Text = styled("span")`
    display: block;
    flex: 0 0 100%;
    font-size: 13px;
    font-weight: normal;
    text-align: center;
`;

const MessageContainer = styled("span")`
    display: block;
    margin-top: 13px;
`;

const MessageWithNumberContainer = styled("span")`
    display: block;
`;

const TooltipContainer = styled("span")`
    display: block;
    margin: 0 0 0 8px;
`;

const StyledTooltip = styled(InfoTooltip)`
    color: ${(props) => props.theme.palette.grey[60]};
    margin: 2px 0 0;

    ${(props) => props.theme.breakpoints.up("desktop")} {
        margin: 4px 0 0;
    }
`;

interface NoOfferProps extends WithTranslation {
    dealerNumber: string;
    displayDealerNumber?: boolean;
    displayTooltip?: boolean;
    paymentType: string | undefined;
}

const defaultProps = {
    displayDealerNumber: false,
    displayTooltip: false,
};

const NoOffers: React.FunctionComponent<NoOfferProps> = ({
    dealerNumber,
    displayDealerNumber,
    displayTooltip,
    paymentType,
    t,
}: NoOfferProps) => {
    let message;

    switch (paymentType) {
        case "lease":
            message = t("CalculatedPayment.NoOffers.messageLease");
            break;
        case "loan":
            message = t("CalculatedPayment.NoOffers.messageLoan");
            break;
        case "cash":
            message = t("CalculatedPayment.NoOffers.messageCash");
            break;
        default:
            message = t("CalculatedPayment.NoOffers.messageCash");
            break;
    }

    const infoTip = message + t("CalculatedPayment.NoOffers.callUs", { dealerNumber });
    return (
        <Root displayTooltip={displayTooltip} className={"NoOffer__root"}>
            <Header displayTooltip={displayTooltip} displayDealerNumber={displayDealerNumber}>
                {displayDealerNumber && <DealerNumber>{dealerNumber}</DealerNumber>}
                {displayDealerNumber && " / "}
                {t("CalculatedPayment.NoOffers.contactUs")}
            </Header>
            {!displayTooltip &&
                (displayDealerNumber ? (
                    <MessageContainer>
                        <Text>{t("CalculatedPayment.NoOffers.messageNoOffersLine1")}</Text>
                        <Text>{t("CalculatedPayment.NoOffers.messageNoOffersLine2")}</Text>
                    </MessageContainer>
                ) : (
                    <MessageWithNumberContainer>
                        <Text>{message}</Text>
                        <Text>{t("CalculatedPayment.NoOffers.callUs", { dealerNumber })}</Text>
                    </MessageWithNumberContainer>
                ))}
            {displayTooltip && (
                <TooltipContainer>
                    <StyledTooltip text={infoTip} />
                </TooltipContainer>
            )}
        </Root>
    );
};

export default withTranslation()(WithDefaults(defaultProps, NoOffers));
